import values from 'lodash/values';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AmenityIconListItem from './AmenityIconListItem';

export default class AmenityIconList extends Component {
    static propTypes = {
        isMonthly: PropTypes.bool.isRequired,
        rate: PropTypes.object.isRequired,
        pill: PropTypes.bool
    };

    _renderInOut() {
        const {
            rate,
            isMonthly,
            pill
        } = this.props;

        if (isMonthly && rate && rate.in_out && rate.in_out.allowed !== 'no') {
            const inOut = rate.in_out.allowed;
            let tip = '';

            switch (inOut) {
                case 'yes':
                    tip = 'Unlimited In/Out';
                    break;

                case 'yes_fee':
                    tip = 'Unlimited In/Out (with fee)';
                    break;

                case 'yes_limited':
                    tip = 'Limited In/Out';
                    break;

                case 'yes_limited_fee':
                    tip = 'Limited In/Out (with fee)';
                    break;
            }

            return [
                (
                    <AmenityIconListItem
                        key={inOut}
                        iconName="amenity-in-out"
                        tip={tip}
                        pill={pill}
                        onShowTooltip={this._onShowTooltip}
                        onHideTooltip={this._onHideTooltip}
                    />
                )
            ];
        } else {
            return null;
        }
    }

    _renderOtherAmenities() {
        const {
            rate,
            pill
        } = this.props;
        const limitAmenities = (
            (pill && rate.amenities.length > 2)
            || (pill && rate.in_out && rate.amenities.length > 1)
        );
        const amenities = (limitAmenities)
            ? rate.amenities.slice(0, 2)
            : rate.amenities;

        return (
            values(amenities).map((amenity, i) => {
                const {
                    name,
                    slug,
                    visible
                } = amenity;

                if (!visible) { return null; }

                return (
                    <AmenityIconListItem
                        key={i}
                        iconName={`amenity-${slug}`}
                        tip={name}
                        pill={pill}
                        onShowTooltip={this._onShowTooltip}
                        onHideTooltip={this._onHideTooltip}
                    />
                );
            })
        );
    }

    render() {
        const {
            rate,
            pill
        } = this.props;
        const items = values(this._renderInOut()).concat(values(this._renderOtherAmenities()));
        const limitAmenities = (
            (pill && rate.amenities.length > 2)
            || (pill && rate.in_out && rate.amenities.length > 1)
        );
        const amenities = (limitAmenities)
            ? rate.amenities.slice(0, 2)
            : rate.amenities;

        return (
            <div className="AmenityIconListContainer">
                <ul
                    className="AmenityIconList"
                    type="inline"
                >
                    {items}
                </ul>
                {limitAmenities &&
                    <span className="AmenityIconListItem-more">
                        + {rate.amenities.length - amenities.length}
                    </span>
                }
            </div>
        );
    }
}
